module.exports = __webpack_public_path__ + "img/wxlecheng.e88ece35.png";